import type {
  BestPriceByOrder,
  BestPriceEntry,
  CptPricePerTonForPurchaseOrder,
  PrepaymentKey,
} from '@/types/buy';

// API отдаёт тип предоплаты как PERCENT_0/PERCENT_100; в гриде ключи «0»/«100».
const PREPAYMENT_FROM_API: Readonly<Record<string, PrepaymentKey>> = {
  PERCENT_0: '0',
  PERCENT_100: '100',
};

/**
 * Свёртка ответа best-price в карту: orderId → лучшая (минимальная) цена продажи по каждой предоплате.
 * Минимум — лучшее для покупателя. Неизвестные типы предоплаты пропускаем.
 */
export function buildBestPriceMap(
  list: readonly CptPricePerTonForPurchaseOrder[] | undefined,
): BestPriceByOrder {
  const map = new Map<number, Partial<Record<PrepaymentKey, BestPriceEntry>>>();
  if (!list) {
    return map;
  }
  for (const order of list) {
    const byPrepayment: Partial<Record<PrepaymentKey, BestPriceEntry>> = {};
    for (const item of order.items ?? []) {
      const key = PREPAYMENT_FROM_API[item.prepaymentType];
      if (!key) {
        continue;
      }
      const current = byPrepayment[key];
      if (!current || item.price < current.price) {
        byPrepayment[key] = {
          price: item.price,
          saleOrderId: item.saleOrderId,
          saleOrderVersion: item.saleOrderVersion,
        };
      }
    }
    if (Object.keys(byPrepayment).length > 0) {
      map.set(order.purchaseOrderId, byPrepayment);
    }
  }
  return map;
}
